var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 110,
    viewBox: "0 0 101 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03873,
    y: 9.9506,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    fill: "#212327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03873,
    y: 9.9506,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3689 30.4181C27.9874 30.4954 27.1527 30.7996 26.5142 31.0939C25.8755 31.3885 25.2566 31.6483 25.1388 31.6714C24.8923 31.72 23.9702 32.475 23.2772 33.1952C23.016 33.4669 22.4718 34.3509 22.068 35.1598C21.3541 36.59 21.3337 36.6914 21.3337 38.8197C21.3337 41.1571 21.4744 41.6741 22.6688 43.7283C22.9734 44.2522 23.1629 44.7771 23.0897 44.8949C23.0168 45.0126 23.0396 45.058 23.1407 44.9958C23.3044 44.895 26.2847 49.8943 26.1462 50.037C26.1152 50.0686 26.2682 50.289 26.4862 50.5269C26.7042 50.7645 27.1947 51.5624 27.5762 52.3C27.9576 53.0377 28.3496 53.6988 28.4473 53.7694C28.5448 53.8399 28.5682 54.0446 28.4991 54.2241C28.4291 54.4061 28.4557 54.4999 28.5593 54.4361C28.7763 54.3025 29.2079 55.0106 29.0224 55.1957C28.9537 55.2642 28.9925 55.3203 29.109 55.3203C29.3605 55.3203 30.1524 56.603 30.1524 57.0107C30.1524 57.1676 30.2214 57.2958 30.3056 57.2958C30.3898 57.2958 30.6332 57.6292 30.8466 58.0366C31.0598 58.4441 31.5705 59.3344 31.9815 60.0156C32.3923 60.6965 32.7286 61.2984 32.7286 61.3531C32.7286 61.4079 32.946 61.7842 33.212 62.1892C33.4777 62.5943 33.7231 63.0591 33.757 63.2221C33.7909 63.3851 33.8727 63.5629 33.9387 63.6172C34.105 63.7541 35.5373 66.1341 35.9596 66.9755C36.1505 67.3558 36.3909 67.8002 36.4937 67.9632C36.9921 68.7528 38.2775 70.9412 38.2775 71.0003C38.2775 71.0372 38.7358 71.8578 39.2961 72.8242C39.8563 73.7904 40.5125 74.9366 40.7544 75.3712C40.9964 75.8058 41.6155 76.8911 42.1305 77.7832C42.6456 78.6751 43.0082 79.4997 42.9365 79.6154C42.8648 79.731 42.907 79.8013 43.0302 79.7715C43.1535 79.7416 43.4803 80.1172 43.7561 80.6061C44.032 81.095 44.3835 81.692 44.5375 81.9326C44.6913 82.1732 44.8172 82.5065 44.8172 82.6734C44.8172 82.8401 44.8875 82.9766 44.9737 82.9766C45.0597 82.9766 45.4832 83.6068 45.915 84.3772C46.3466 85.1475 46.9128 86.1552 47.1734 86.6166C47.4338 87.0779 47.8958 87.6219 48.1997 87.8256C48.5037 88.0293 48.7204 88.2477 48.6811 88.311C48.589 88.4597 49.6211 88.5909 50.7879 88.5786C51.9042 88.5668 52.7419 88.0281 53.3665 86.92C53.6093 86.4896 53.8806 86.1374 53.9695 86.1374C54.0585 86.1374 54.1168 86.0708 54.0993 85.9892C54.0637 85.8243 54.4184 85.0141 54.7262 84.557C54.836 84.394 55.5353 83.2167 56.2804 81.9409C57.0253 80.665 57.7081 79.6871 57.7974 79.7679C57.887 79.8485 57.8908 79.7952 57.806 79.649C57.7126 79.4884 57.8177 79.1597 58.0713 78.8173C58.3022 78.5062 58.491 78.2127 58.491 78.165C58.491 78.1174 58.8559 77.4796 59.302 76.7478C60.2732 75.1543 60.7447 74.339 61.5128 72.9248C62.5387 71.0358 63.1689 70.1244 63.3409 70.2802C63.4333 70.364 63.4444 70.3207 63.3655 70.1842C63.2862 70.0471 63.4051 69.6797 63.631 69.3636C63.856 69.0487 64.0399 68.7479 64.0399 68.6951C64.0399 68.6424 64.8425 67.2511 65.8234 65.6035C66.8044 63.956 67.607 62.5406 67.607 62.4584C67.607 62.3762 67.7681 62.1366 67.9649 61.926C68.1617 61.7152 68.3446 61.4541 68.3711 61.3454C68.5136 60.7621 71.524 55.9301 71.6651 56.0579C71.7569 56.1411 71.7769 56.1127 71.7095 55.9945C71.6422 55.8764 71.94 55.1777 72.3714 54.4416C72.8028 53.7056 73.1558 53.072 73.1558 53.0335C73.1558 52.9952 73.6463 52.1574 74.2457 51.1719C74.8452 50.1863 75.3357 49.3457 75.3357 49.3039C75.3357 49.262 75.7816 48.5111 76.3265 47.6352C76.8715 46.7593 77.3174 46.0049 77.3174 45.959C77.3174 45.913 77.7633 45.1201 78.3083 44.1971C78.8532 43.274 79.2991 42.3716 79.2991 42.1914C79.2991 42.0113 79.3693 41.9072 79.4551 41.9599C79.5409 42.0129 79.6315 41.0625 79.6566 39.848C79.6963 37.926 79.6386 37.463 79.2109 36.2736C78.9408 35.5219 78.6404 34.8552 78.5437 34.792C78.4468 34.7286 78.255 34.4641 78.1174 34.2039C77.5859 33.1986 76.2189 31.9675 75.0069 31.4025C72.3793 30.1781 73.4964 30.2299 50.2748 30.2548C38.608 30.2672 28.7503 30.3407 28.3689 30.4181ZM47.1952 54.7241C47.1952 64.7219 47.1591 72.9018 47.115 72.9018C47.0218 72.9018 45.1283 69.715 45.0904 69.4942C45.0764 69.4126 45.0431 69.2794 45.0167 69.1979C44.9902 69.1163 44.9812 68.9764 44.9967 68.8869C45.0124 68.7972 44.9472 68.772 44.8518 68.8308C44.7567 68.8895 44.5548 68.6961 44.4032 68.401C44.2516 68.1058 43.8691 67.42 43.5532 66.8767C41.4508 63.2618 39.4665 59.804 39.4665 59.7552C39.4665 59.7236 39.0174 58.9759 38.4687 58.0938C37.9126 57.2001 37.5319 56.3843 37.6086 56.2509C37.6845 56.1194 37.6732 56.0779 37.5839 56.1587C37.4943 56.2395 37.3239 56.1344 37.2052 55.925C36.5145 54.7067 35.1408 52.321 33.9567 50.2829C33.515 49.5223 33.1248 48.7671 33.0897 48.6046C33.0546 48.442 32.9181 48.2197 32.7863 48.1107C32.6547 48.0016 32.0414 47.0234 31.4235 45.9369C30.8056 44.8504 30.1373 43.6948 29.9384 43.3688C28.8038 41.5097 27.5762 39.1167 27.5762 38.7642C27.5762 38.0248 27.9311 37.4087 28.6003 36.9859C29.2464 36.5778 29.4538 36.5685 38.2279 36.5576L47.1952 36.5464V54.7241ZM72.3784 37.526C72.8657 38.0118 72.9576 38.2619 72.9576 39.1016C72.9576 40.0425 72.3889 41.4518 72.118 41.182C72.0565 41.1207 72.0199 41.1899 72.0361 41.3355C72.0767 41.697 68.1438 48.394 67.9581 48.2796C67.8765 48.2292 67.8551 48.3063 67.9108 48.4507C67.9663 48.5951 67.7869 49.0168 67.512 49.3882C67.2374 49.7596 67.0124 50.1249 67.0124 50.2003C67.0124 50.4957 64.8918 53.9327 64.7672 53.8393C64.694 53.7846 64.6754 53.7956 64.7257 53.864C64.7759 53.9322 64.6082 54.3543 64.3532 54.8023C63.7386 55.8807 62.096 58.6995 61.8637 59.0737C61.7627 59.2366 60.9928 60.5701 60.1529 62.0368C57.1183 67.337 56.2586 68.7534 56.0767 68.7534C55.9748 68.7534 55.9324 68.82 55.9828 68.9015C56.0331 68.9831 55.8605 69.4053 55.5995 69.8399C55.3383 70.2745 55.0625 70.7634 54.9862 70.9264C54.9099 71.0894 54.5528 71.7116 54.1927 72.3092L53.5377 73.3957L53.5373 55.1721L53.5367 36.9486H62.6679H71.7991L72.3784 37.526Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03873,
    y: 1.12699,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    fill: "#373C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03873,
    y: 1.12699,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7298 105.026L14.6819 105.907",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2036 23.7044C32.0606 23.7044 32.5134 23.2046 33.9177 24.1571C36.1561 25.6328 36.9179 28.5381 36.9179 30.3951C36.9179 34.1092 33.6086 38.6809 29.9894 38.6809C26.3946 38.6809 23.7993 34.5384 23.5137 30.9428V30.9192C23.5137 30.7529 23.5137 30.5623 23.5137 30.3951C23.5137 26.7037 26.513 23.7044 30.2036 23.7044ZM26.7986 41.1317C28.6792 43.0123 31.7507 43.0123 33.6078 41.1317L34.8693 39.8937H35.726C38.0358 39.8937 38.6069 39.3461 39.9399 40.3699C41.702 41.7029 42.1068 44.0126 42.1068 45.6555V52.6553H36.9162H23.6313H18.3222L17.2983 51.1317L18.3222 45.6555C19.0605 41.7508 20.7269 39.8937 24.703 39.8937H25.5597L26.7986 41.1317Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0837 51.1317L42.1076 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.894 51.1317L36.9179 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2991 51.1317L18.3229 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.68 38.3701H24.5367L25.7747 39.6317C27.6553 41.5122 30.7269 41.5122 32.5839 39.6317L33.8455 38.3701H34.7022C38.6783 38.3701 41.083 40.1793 41.083 44.1554V51.1309H17.2983V44.1554C17.2992 40.1793 19.7038 38.3701 23.68 38.3701Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1799 22.1798C25.4893 22.1798 22.49 25.18 22.49 28.8941C22.49 32.5846 25.4902 37.394 29.1799 37.394C32.894 37.394 35.8942 32.5846 35.8942 28.8941C35.8942 25.18 32.894 22.1798 29.1799 22.1798Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.49 29.4183C26.4897 29.299 29.1799 28.99 31.9894 26.2283C31.9894 26.2283 33.0133 28.1803 35.8942 28.895C35.8942 25.1809 32.894 22.1808 29.1799 22.1808C25.4893 22.1808 22.49 25.1809 22.49 28.895C22.49 29.0613 22.49 29.2512 22.49 29.4183Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.894 51.1318V44.6082",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.894 28.8942C35.894 28.8942 36.823 30.4421 36.7751 31.8229",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.894 28.8941C35.894 28.8941 36.823 30.442 36.7751 31.8228C36.87 31.3466 36.9179 30.8704 36.9179 30.3942C36.9179 28.5371 36.1561 25.6327 33.9177 24.1561C35.1322 25.3706 35.894 27.037 35.894 28.8941Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3228 51.1318V44.6082",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3228 51.1317L23.3701 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0117 23.7044C72.8452 23.7044 73.2971 23.2046 74.7258 24.1571C76.9398 25.6328 77.726 28.5381 77.726 30.3951C77.726 34.1092 74.4167 38.6809 70.7975 38.6809C67.1783 38.6809 64.5838 34.5384 64.3218 30.9428V30.9192C64.2983 30.7529 64.2983 30.5623 64.2983 30.3951C64.2974 26.7037 67.2976 23.7044 71.0117 23.7044ZM67.6067 41.1317C69.4873 43.0123 72.5353 43.0123 74.4159 41.1317L75.6539 39.8937H76.5106C78.8204 39.8937 79.3915 39.3461 80.7488 40.3699C82.5109 41.7029 82.8914 44.0126 82.8914 45.6555V52.6553H77.7008H64.4159H59.1303L58.1064 51.1317L59.1303 45.6555C59.8442 41.7508 61.535 39.8937 65.5111 39.8937H66.3443L67.6067 41.1317Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8684 51.1317L82.8923 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6775 51.1317L77.7014 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1072 51.1317L59.131 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4881 38.3701H65.3213L66.5828 39.6317C68.4634 41.5122 71.5115 41.5122 73.392 39.6317L74.6301 38.3701H75.4868C79.4629 38.3701 81.8676 40.1793 81.8676 44.1554V51.1309H58.1064V44.1554C58.1073 40.1793 60.4884 38.3701 64.4881 38.3701Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9877 22.1798C66.2736 22.1798 63.2734 25.18 63.2734 28.8941C63.2734 32.5846 66.2736 37.394 69.9877 37.394C73.6783 37.394 76.6776 32.5846 76.6776 28.8941C76.6776 25.18 73.6783 22.1798 69.9877 22.1798Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2971 29.4183C67.2732 29.299 69.9635 28.99 72.7965 26.2283C72.7965 26.2283 73.7968 28.1803 76.6769 28.895C76.6769 25.1809 73.6767 22.1808 69.987 22.1808C66.2729 22.1808 63.2727 25.1809 63.2727 28.895C63.2735 29.0613 63.2735 29.2512 63.2971 29.4183Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6775 51.1318V44.6082",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6775 28.8942C76.6775 28.8942 77.63 30.4421 77.5586 31.8229",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6776 28.8941C76.6776 28.8941 77.6301 30.442 77.5587 31.8228C77.6536 31.3466 77.725 30.8704 77.725 30.3942C77.725 28.5371 76.9397 25.6327 74.7249 24.1561C75.9394 25.3706 76.6776 27.037 76.6776 28.8941Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1306 51.1318V44.6082",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1306 51.1317L64.1545 52.6553",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.775 75.5118C41.7752 75.5118 44.2034 77.94 44.2034 80.9402C44.2034 83.9403 41.7752 86.3685 38.775 86.3685C35.7749 86.3685 33.3467 83.9403 33.3467 80.9402C33.3467 77.94 35.7749 75.5118 38.775 75.5118Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.775 74.226C41.7752 74.226 44.2034 76.6541 44.2034 79.6543C44.2034 82.6545 41.7752 85.0827 38.775 85.0827C35.7749 85.0827 33.3467 82.6545 33.3467 79.6543C33.3467 76.6541 35.7749 74.226 38.775 74.226Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9412 84.6064L41.0125 85.6773",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.775 75.9158C40.8462 75.9158 42.5126 77.5822 42.5126 79.6534C42.5126 81.7011 40.8462 83.391 38.775 83.391C36.7037 83.391 35.0374 81.7003 35.0374 79.6534C35.0365 77.583 36.7037 75.9158 38.775 75.9158Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6544 82.4395C55.1305 82.4395 53.0828 84.4872 53.0828 87.0111C53.0828 89.535 55.1305 91.5828 57.6544 91.5828C60.1784 91.5828 62.2261 89.535 62.2261 87.0111C62.2261 84.4872 60.1784 82.4395 57.6544 82.4395Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6544 81.3441C55.1305 81.3441 53.0828 83.3918 53.0828 85.9158C53.0828 88.4397 55.1305 90.4874 57.6544 90.4874C60.1784 90.4874 62.2261 88.4397 62.2261 85.9158C62.2261 83.3918 60.1784 81.3441 57.6544 81.3441Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6544 82.7729C55.9167 82.7729 54.5115 84.1773 54.5115 85.9159C54.5115 87.6537 55.9158 89.0589 57.6544 89.0589C59.3922 89.0589 60.8209 87.6545 60.8209 85.9159C60.8209 84.1781 59.3931 82.7729 57.6544 82.7729Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8216 38.1558C50.1784 40.5126 54.0353 40.5126 56.3929 38.1558L57.9409 36.6078H59.0126C61.9414 36.6078 62.6318 35.9174 64.3217 37.2033C66.5357 38.8941 67.0363 41.775 67.0363 43.8462V52.6317H60.5362H43.8228H37.1799L35.894 50.7268L37.1799 43.8462C38.1089 38.9419 40.2036 36.6087 45.1793 36.6087H46.2745L47.8216 38.1558Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1078 16.2518C54.4175 16.2518 54.9887 15.6329 56.7743 16.823C59.5603 18.7036 60.5363 22.3463 60.5363 24.6796C60.5363 29.3226 56.3695 35.0835 51.8465 35.0835C47.2993 35.0835 44.037 29.8929 43.7044 25.3456C43.7044 25.1079 43.6809 24.8929 43.6809 24.6787C43.6792 20.0374 47.4647 16.2518 52.1078 16.2518Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7495 50.7268L67.0354 52.6317",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2502 50.7268L60.5353 52.6317",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.894 50.7268L37.1791 52.6317",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8933 34.7039H44.965L46.5365 36.2753C48.8933 38.6321 52.7501 38.6321 55.1078 36.2753L56.6549 34.7039H57.7266C62.7266 34.7039 65.7503 36.9657 65.7503 41.9657V50.7269H35.8948V41.9657C35.8939 36.9657 38.9176 34.7039 43.8933 34.7039Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8218 14.3713C46.1788 14.3713 42.3933 18.1333 42.3933 22.7755C42.3933 27.442 46.1788 33.4659 50.8218 33.4659C55.4649 33.4659 59.2504 27.442 59.2504 22.7755C59.2504 18.1333 55.4649 14.3713 50.8218 14.3713Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4177 23.4659C47.4177 23.2996 50.7983 22.9183 54.3461 19.4419C54.3461 19.4419 55.632 21.8944 59.2504 22.7755C59.2504 18.1325 55.4649 14.3713 50.8218 14.3713C46.1788 14.3713 42.3933 18.1333 42.3933 22.7755C42.3933 23.014 42.3933 23.2282 42.4177 23.4659Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2502 50.7268V42.5125",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2502 22.7754C59.2502 22.7754 60.4169 24.7274 60.3455 26.466",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2502 22.7754C59.2502 22.7754 60.4169 24.7273 60.3455 26.4659C60.4647 25.8469 60.5361 25.2514 60.5361 24.6803C60.5361 22.347 59.5602 18.7043 56.7742 16.8237C58.2978 18.3473 59.2502 20.4664 59.2502 22.7754Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2034 50.7268V42.5125",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2034 50.7268L43.4884 52.6317",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6072 54.4888C43.9647 54.4888 39.3931 59.0839 39.3931 64.7265C39.3931 70.369 43.9647 74.9406 49.6072 74.9406C55.2733 74.9406 59.8449 70.369 59.8449 64.7265C59.8449 59.0839 55.2741 54.4888 49.6072 54.4888Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6072 52.0841C43.9647 52.0841 39.3931 56.6557 39.3931 62.2983C39.3931 67.9408 43.9647 72.5125 49.6072 72.5125C55.2733 72.5125 59.8449 67.9408 59.8449 62.2983C59.8449 56.6557 55.2741 52.0841 49.6072 52.0841Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5127 71.6541L45.3699 73.6304",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6071 55.2506C45.7267 55.2506 42.5837 58.4171 42.5837 62.2983C42.5837 66.1787 45.7267 69.3217 49.6071 69.3217C53.5118 69.3217 56.6548 66.1787 56.6548 62.2983C56.6548 58.4171 53.5118 55.2506 49.6071 55.2506Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.202 57.9408L77.059 63.9646L83.082 63.7261V65.4882L77.725 67.3209L75.202 73.7018L72.678 67.3209L67.321 65.4882V63.7261L73.3449 63.9646L75.202 57.9408Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.202 55.8696L77.059 61.8927L83.082 63.7262L77.059 65.5832L75.202 70.9402L73.3449 65.5832L67.321 63.7262L73.3449 61.8927L75.202 55.8696Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.678 67.321V65.4883",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7014 67.3924V65.3926",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2019 73.7018V70.8209",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5839 14.1327L42.1789 19.2755L47.3217 19.0848V20.5849L42.75 22.1564L40.5839 27.5847L38.4413 22.1564L33.8696 20.5849V19.0848L39.0124 19.2755L40.5839 14.1327Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5839 12.347L42.1789 17.5142L47.3217 19.0848L42.1789 20.6563L40.5839 25.2279L39.0124 20.6563L33.8696 19.0848L39.0124 17.5142L40.5839 12.347Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4414 22.1564V20.585",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7268 22.2278V20.49",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.584 27.5848V25.1322",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2754 61.298L25.4421 65.1305L29.2989 64.9877V66.1073L25.8704 67.2975L24.2754 71.345L22.6561 67.2975L19.2275 66.1073V64.9877L23.0844 65.1305L24.2754 61.298Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2754 59.9642L25.4421 63.7976L29.2989 64.9878L25.4421 66.1788L24.2754 69.5829L23.0844 66.1788L19.2275 64.9878L23.0844 63.7976L24.2754 59.9642Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 67.2975V66.1073",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8704 67.3211V66.036",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2756 71.345V69.5115",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5364 72.9636V63.7976",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1548 81.3685V78.7496",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2502 79.7257V75.1305",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4641 48.3222V43.7506",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.322 73.4398V71.6785",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalls);
export default __webpack_public_path__ + "static/media/emptyCalls.6899bdacad06ab2312aeb8b79cd908f7.svg";
export { ForwardRef as ReactComponent };